import { useEffect, useState } from 'react';
import { toAssetUrl } from '../../utils/assetBase';

const AD_DURATION_MS = 5000;

const QrAd = ({ imageUrl, onSkip }) => {
    const [remaining, setRemaining] = useState(Math.ceil(AD_DURATION_MS / 1000));
    const [canSkip, setCanSkip] = useState(false);

    useEffect(() => {
        const tickInterval = setInterval(() => {
            setRemaining((r) => {
                if (r <= 1) {
                    clearInterval(tickInterval);
                    setCanSkip(true);
                    return 0;
                }
                return r - 1;
            });
        }, 1000);
        return () => clearInterval(tickInterval);
    }, []);

    return (
        <div
            className="fixed inset-0 z-50 flex flex-col bg-black"
            style={{ touchAction: 'manipulation' }}
        >
            {/* Şəkil */}
            <div className="relative flex-1 overflow-hidden">
                {imageUrl ? (
                    <img
                        src={toAssetUrl(imageUrl)}
                        alt="Reklam"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-white/50">
                        Reklam yüklənir...
                    </div>
                )}

                {/* Sayğac yuxarı sağda */}
                {!canSkip && (
                    <div className="absolute top-4 right-4 rounded-full bg-black/60 px-3 py-1.5 text-sm font-bold text-white shadow-lg backdrop-blur">
                        {remaining}s
                    </div>
                )}
            </div>

            {/* "Menyuya keç" düyməsi 5 sn sonra çıxır */}
            <div className="bg-black/90 px-5 py-4">
                {canSkip ? (
                    <button
                        type="button"
                        onClick={onSkip}
                        className="w-full rounded-2xl px-6 py-4 text-base font-bold uppercase tracking-wider text-white shadow-lg transition-all hover:-translate-y-0.5 active:scale-[0.98]"
                        style={{
                            background: 'linear-gradient(135deg, #0090bb, #006f91)',
                            boxShadow: '0 10px 30px rgba(0,144,187,0.45)'
                        }}
                    >
                        Menyuya keç →
                    </button>
                ) : (
                    <div className="text-center text-xs uppercase tracking-[0.25em] text-white/60">
                        Menyu {remaining} saniyəyə açılır
                    </div>
                )}
            </div>
        </div>
    );
};

export default QrAd;
